module.exports = __webpack_public_path__ + "img/brett-magner.97e3a745.jpg";